import {
  GET_MUST_SELL_SKU,
  GET_MUST_SELL_SKUS,
  ADD_PRODUCT_GROUPS_TO_MUST_SELL,
  DELETE_MUST_SELL_SKUS,
  CREATE_MUST_SELL_SKU,
  REMOVE_PRODUCT_GROUPS_FROM_MUST_SELL,
  UPDATE_MUST_SELL_SKU,
  GET_MUST_SELL_SKUS_BY_IDS
} from "../constants/action-types";

import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();


/* 
  Get must sell skus.
*/
export const getMustSellSkus = callback => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells`, {
    method: "get"
  }).then(res => {
    const data = res.data;

    dispatch({
      type: GET_MUST_SELL_SKUS,
      payload: data.mustSellSkus
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
};

/* 
  Get must sell sku.
*/
export const getMustSellSku = (skuId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells/${skuId}`, {
    method: "get"
  }).then(res => {
    const data = res.data;

    dispatch({
      type: GET_MUST_SELL_SKU,
      payload: data.mustSellSku
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
};

/* 
  Get must sell skus by ids.
*/
export const getMustSellSkusForIds = (mustSellSkus, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells?forIds=true`, {
    method: "post",
    data: mustSellSkus
  }).then(res => {
    const data = res.data;

    dispatch({
      type: GET_MUST_SELL_SKUS_BY_IDS,
      payload: data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
};

/*
  Create must-sell sku.
*/
export const createMustSellSku = (name, callback) => dispatch => {

  const newMustSellSku = {
    Name: name,
    ProductGroups: []
  }

  adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells/`, {
    method: "post",
    data: newMustSellSku
  }).then(res => {
    const id = res.data;

    newMustSellSku.id = id
    
    dispatch({
      type: CREATE_MUST_SELL_SKU,
      payload: newMustSellSku
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
}

/*
  Delete must-sell sku.
*/
export const removeMustSellSkus = (mustSellSkuIds, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells/`, {
    method: "delete",
    data: mustSellSkuIds
  }).then(res => {
    dispatch({
      type: DELETE_MUST_SELL_SKUS,
      payload: mustSellSkuIds
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
}

export const updateMustSellSku = (mustSell, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells`, {
    method: "post",
    data: mustSell
  }).then(res => {
    dispatch({
      type: UPDATE_MUST_SELL_SKU,
      payload: mustSell
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  })
}

// /*
//   Add Product Groups to Must Sell SKU.
// */
// export const addProductGroupsToMustSellSku = (productGroupIds, mustSellSkuId, callback) => dispatch => {
//   adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells/${mustSellSkuId}/productGroups`, {
//     method: "post",
//     data: productGroupIds
//   }).then(res => {
//     dispatch({
//       type: ADD_PRODUCT_GROUPS_TO_MUST_SELL,
//       payload: productGroupIds
//     });

//     callback(true);
//   }).catch((error) => {
//     console.log(`Exception Occurred: ${error}`);
//     callback(false);
//   })
// }

// /*
//   Remove Product Groups from Must Sell SKU.
// */
// export const removeProductGroupsFromMustSellSku = (productGroupIds, mustSellSkuId, callback) => dispatch => {
//   adalApiFetch(Axios, `${API_CONFIG.URL}/must-sells/${mustSellSkuId}/productGroups`, {
//     method: "delete",
//     data: productGroupIds
//   }).then(res => {
//     dispatch({
//       type: REMOVE_PRODUCT_GROUPS_FROM_MUST_SELL,
//       payload: productGroupIds
//     });

//     callback(true);
//   }).catch((error) => {
//     console.log(`Exception Occurred: ${error}`);
//     callback(false);
//   })
// }